import { render } from "./CollabHelpNeverDone.vue?vue&type=template&id=d21d4042&scoped=true"
import script from "./CollabHelpNeverDone.vue?vue&type=script&lang=js"
export * from "./CollabHelpNeverDone.vue?vue&type=script&lang=js"

import "./CollabHelpNeverDone.vue?vue&type=style&index=0&id=d21d4042&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21d4042"]])

export default __exports__